<template>
    <div class="page">
        <div class="baner-subpage">
            <div class="container">
                <div class="text">Judaszowce, lecz nie tylko ...</div>
            </div>
        </div>
        <div class="content">
            <div class="container">
                <h2 class="pageHeader text-center">
                    Galeria
                </h2>
                <div class="galeria">

                    <div class="row">
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/357.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/357_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/20160610_101856.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/20160610_101856_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/20170802_185531.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/20170802_185531_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/20171013_143712.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/20171013_143712_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/20180525_080119.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/20180525_080119_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/20180624_113635.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/20180624_113635_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/20180625_090820.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/20180625_090820_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/20180707_142554.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/20180707_142554_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/20180905_133541.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/20180905_133541_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscf0066.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscf0066_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscf0107.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscf0107_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscf0109.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscf0109_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscf0266.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscf0266_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscf0267.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscf0267_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscf2035.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscf2035_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscf2949.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscf2949_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscf2951.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscf2951_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscf2973.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscf2973_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscf3005.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscf3005_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscf3026.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscf3026_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscf3033.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscf3033_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscf3092.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscf3092_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscn8919.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscn8919_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscn9397.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscn9397_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscn9753.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscn9753_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/dscn9805.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/dscn9805_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/image1-(2).jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/image1-(2)_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/image1-(3).jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/image1-(3)_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/galeria/img_20190111_105652.jpg" title="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych">
                                <img class="img-fluid" src="/static/img/galeria/img_20190111_105652_255x255.jpg" alt="Galeria - Olszewscy R.J. Szkółka drzew ozdobnych"/>
                            </a>
                        </div>




                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>

    import 'owl.carousel/dist/owl.carousel.js'
    import 'owl.carousel/dist/assets/owl.carousel.min.css'
    import 'owl.carousel/dist/assets/owl.theme.default.min.css'
    import '../../static/plugins/venobox/venobox.css'
    import '../../static/plugins/venobox/venobox.js'
    export default {
        components: {



        },
        methods: {

        },
        mounted: function () {
            $(".galeria a").venobox();

        }
    }



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Galeria.vue